import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HelpDialogTop, HelpDialogTraning1, HelpDialogTraning2, HelpDialogTraning3, HelpDialogTraning4, HelpDialogTraning5 } from '.';
import { HelpDialogChangeRenketsu, HelpDialogChangeDouka, HelpDialogChangedatsuraku, HelpDialogChangeragyoka, HelpDialogChangejakkei } from '.';

const HelpDialog = (props) => {
    return(
        <Body Display={props.display}>
            {/* <Back Display={props.display}  onClick='null'></Back> */}
            <Back Display={props.display} ></Back>
            <Dialog Display={props.display}>
                <Contents>
                    { renderHelp(props) }
                </Contents>
                <ControlWrap>
                    <Button onClick={props.closeHelp}>閉じる</Button>
                </ControlWrap>
            </Dialog>
        </Body>
    );
}

const renderHelp = (props) => {

    if(props.voiceChangeMark){
        if(props.voiceChangeMark === 1){
            return <HelpDialogChangeRenketsu />;
        }
        if(props.voiceChangeMark === 2){
            return <HelpDialogChangeDouka />;
        }
        if(props.voiceChangeMark === 3){
            return <HelpDialogChangedatsuraku />;
        }
        if(props.voiceChangeMark === 4){
            return <HelpDialogChangeragyoka />;
        }
        if(props.voiceChangeMark === 5){
            return <HelpDialogChangejakkei />;
        }
    } else {

        if (props.page === 0) {
            return <HelpDialogTop />;
        }
        if (props.page === 1) {
            return <HelpDialogTraning1 />;
        }
        if (props.page === 2) {
            return <HelpDialogTraning2 />;
        }
        if (props.page === 3) {
            return <HelpDialogTraning3 />;
        }
        if (props.page === 4) {
            return <HelpDialogTraning4 />;
        }
        if (props.page === 5) {
            return <HelpDialogTraning5 />;
        }
        return null;
        }
    }
    export { HelpDialog };

    HelpDialog.propTypes = {
        display: PropTypes.bool.isRequired,
        closeHelp: PropTypes.func.isRequired,
};
    
const Body = styled.div`
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    pointer-events: ${props => (props.Display ? '' : 'none')};
    position: absolute;
    // position: fixed;
    z-index: 3;
`;

const Back = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    background-color: #000;
    opacity: ${props => (props.Display ? '0.2' : '0')};
    transition-duration: 0.2s;

    width: 100%;
    height: 100%;
`;

const Dialog = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background-color: #fff;
    opacity: ${props => (props.Display ? '1' : '0')};
    text-align: left;
    transition-duration: 0.2s;

    border-radius: 10px;

    width: 90%;
    // min-width: 300px;
    max-width: 1000px;
    z-index: 4;
`;

const ControlWrap = styled.div`
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #ddd;
`;
const Button = styled.div`
    flex: 1;
    height: auto
    font-size: inherit;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #ddd;
    cursor: pointer;
    Color: #000;
`;

const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: left;
    flex-direction: column;
    padding: 10px 10px 10px 10px;
    font-size: 14px;
    // height: 90%;
    min-height: 100px;
    max-height: 480px;
    // const width = window.parent.screen.width + "px";
    // height: (window.innerHeight  - 64 - 51) + "px";
    overflow-y: auto;
    `;
